class Deckplans {
    constructor() {
        this.cname = "[data-comp='deckplans']";
        this.components = document.querySelectorAll(this.cname);

        if (this.components.length) {
            this.init();
        }
    }

    init() {
        this.components.forEach( component => {
            this.createFilters(component);
            this.splide(component);
            this.events(component);
            this.activeFirstElement(component);
        });
    }

    createFilters(component) {
        let filtersItems = component.querySelectorAll("[data-item]");
        let filterContainer = component.querySelector("[data-comp='filters']");

        let filtersHTML = Array.from(filtersItems).map(item => `
            <li class="has-label-font-size has-cream-background-color" data-value="${item.dataset.item}">${item.textContent}</li>
        `).join("");

        filterContainer.innerHTML = filtersHTML;
        filterContainer.classList.add("show");
    }
    splide(component) {
        let sliders = component.querySelectorAll(".splide");

        if (sliders.length) {
            sliders.forEach( slider => {

                let isOnlyOne = slider.querySelectorAll(".splide__slide").length <= 1;
                this.setStates(slider);

                let sliderNode = new Splide(slider, {
                    type: slider.dataset.type === "true" ? 'loop' : 'slide',
                    autoplay: slider.dataset.arrows === "true",
                    arrows: slider.dataset.arrows === "true",
                    pagination: slider.dataset.pagination === "true",
                    speed: parseInt(slider.dataset.speed) || 400,
                    interval: parseInt(slider.dataset.interval) || 5000,
                    start: 0,
                    drag: !isOnlyOne
                });

                sliderNode.on('mounted', () => {
                    let slide = sliderNode.Components.Slides.getAt(0).slide;
                    this.everyoneOnPause(slider);
                    this.handleVideoAudio(slide);
                });

                sliderNode.on('move', newIndex => {
                    let slide = sliderNode.Components.Slides.getAt(newIndex).slide;
                    this.everyoneOnPause(slider);
                    this.handleVideoAudio(slide);
                });

                sliderNode.mount();

            });
        }
    }
    events(component) {
        let filterContainer = component.querySelector("[data-comp='filters']");
        filterContainer.addEventListener('click', e => {
            let target = e.target;
            if (target.dataset.value) {
                this.filter(component, target);
            }
        });
    }

    filter(component, target) {
        let tabs = component.querySelectorAll("[data-content]");
        let filterContainer = component.querySelectorAll("[data-comp='filters'] li");
        
        if (tabs.length) {
            // Reset
            filterContainer.forEach(filter => filter.classList.remove("active"));
            tabs.forEach(tab => tab.classList.remove("active"));

            // Active
            target.classList.add("active");
            tabs.forEach( tab => {
                if (tab.dataset.content === target.dataset.value) {
                    tab.classList.add("active");
                }
            });
        }
    }
    activeFirstElement(component) {
        component.querySelector("[data-comp='filters'] li").classList.add("active");
        component.querySelector("[data-content]:first-child").classList.add("active");
    }

    handleVideoAudio(slide) {
        let video = slide.querySelector('video');
        if (video) {
            this.playVideo(video);
        }
    }

    playVideo(video) {
        if (video.dataset.muted === "false") video.muted = false;
        if (video.dataset.paused === "false") video.play();
    }

    pauseVideo(video) {
        video.muted = true;
        video.pause();
    }

    setStates(slider) {
        let sliderItems = slider.querySelectorAll(".splide__slide");
        if (sliderItems.length) {
            Array.from(sliderItems).forEach(slide => {
                let video = slide.querySelector('video');
                if (video) {
                    video.dataset.muted = video.muted ? "true" : "false";
                    video.dataset.paused = video.autoplay ? "false" : "true";
                }
            });
        }
    }

    everyoneOnPause(slider) {
        let sliderItems = slider.querySelectorAll(".splide__slide");
        if (sliderItems.length) {
            Array.from(sliderItems).forEach(slide => {
                let video = slide.querySelector('video');
                if (video) this.pauseVideo(video);
            });
        }
    }

}

new Deckplans();
